<ul class="tree-menu" >

  <li *ngFor="let node of data" >
    <ng-container [ngSwitch]="node.type">
      <!-- parent node -->
      <ng-container *ngSwitchCase="nodeType.PARENT">
        <div class="row">
          <div (mouseup)="togglNodeExpand(node)" class="tree-parent-container">
            <span [ngClass]="{'down': node.expanded}" class="caret"></span>
            <span>{{node.name}}</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="nodeType.FILTER" [ngSwitch]="node.filter.type">
        <!-- check box -->
        <ng-container *ngSwitchCase="filterType.CHECK_BOX">
          <label class="row">
            <div class="col-sm-12 col-xs-12 checkbox-container" >
              <checkbox [node]="node" (onChange)="toggleCheckbox($event, {
                type: node.filter.type,
                name: node.filter.name,
                key: node.filter.key,
                value: node.filter.value,
                logicalOperator: node.filter.logicalOperator,
                comparator: node.filter.comparator,
                groupLogicalOperator: node.filter.groupLogicalOperator
              })"></checkbox>
            </div>
          </label>
        </ng-container>
        <!-- check box inline -->
        <ng-container *ngSwitchCase="filterType.INLINE_CHECK_BOX">
          <div class="row" style="margin-left: -13px;">
            <label class="col-sm-4 inline-checkbox" style="padding-bottom: 10px;">
              <checkbox [node]="node" (onChange)="toggleCheckbox($event, {
                type: node.filter.type,
                name: node.filter.name,
                key: node.filter.key,
                value: node.filter.value,
                logicalOperator: node.filter.logicalOperator,
                comparator: node.filter.comparator,
                groupLogicalOperator: node.filter.groupLogicalOperator
              })"></checkbox>
            </label>
          </div>
        </ng-container>

        <!-- range -->
        <ng-container *ngSwitchCase="filterType.RANGE" >
          <div class="row filter-slider" style="height: 50px; padding-top: 15px; padding-bottom: 10px;" *ngIf="showMedida(node.filter)">
            <div class="col-sm-12" style="padding-left: 0; padding-right: 0; padding-bottom: 10px;">
              <span>{{node.name}}</span>
            </div>
            <div class="col-sm-12" style="padding-left: 0; padding-bottom: 10px;">
              <ng5-slider
                [value]="node.filter.value"
                (valueChange)="emitValue({
                  key: 'min' + node.filter.key,
                  value: $event,
                  name: node.filter.name,
                  logicalOperator: node.filter.logicalOperator,
                  type: node.filter.type,
                  prevValue: node.filter.value,
                  comparator: comparisonOperator.GREATER_OR_EQUAL_THAN ,
                  groupLogicalOperator: node.filter.groupLogicalOperator
                })"
                [highValue]="node.filter.valueMax"
                (highValueChange)="emitValue({
                  key: 'max' + node.filter.key,
                  value: $event,
                  name: node.filter.name,
                  logicalOperator: node.filter.logicalOperator,
                  type: node.filter.type,
                  prevValue: node.filter.valueMax,
                  comparator: comparisonOperator.LESS_OR_EQUAL_THAN,
                  groupLogicalOperator: node.filter.groupLogicalOperator
                })"
                [options]="{
                  floor: node.minRange || 0,
                  ceil: node.maxRange || 0,
                  step: node.step || 1,
                  showTicks: true,
                  showTicksValues: true,
                  animate: false,
                  stepsArray : node.stepsArray
                }"></ng5-slider>
            </div>
          </div>
        </ng-container>

        <!-- range single -->
        <ng-container *ngSwitchCase="filterType.RANGE_UNIQUE">
          <div class="row" style="height: 50px; padding-top: 15px;">
            <div class="col-sm-4">
              <span>{{node.filter.name}}</span>
            </div>
            <div class="col-sm-8 unique-range">
              <ng5-slider
                [value]="node.filter.value"
                (valueChange)="emitValue({
                  key: node.filter.key,
                  name: node.filter.name,
                  value: $event
                })"
                [options]="{
                  floor: node.minRange || 0,
                  ceil: node.maxRange || 0,
                  step: node.step || 1,
                  showTicks: true,
                  showTicksValues: true,
                  animate: false,
                  stepsArray : node.stepsArray
                }"></ng5-slider>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <tree-menu *ngIf="node.children
      && node.children.length
      && node.expanded"
      [data]="node.children">
    </tree-menu>
  </li>
</ul>
